import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { AnyDate, DateFormats, formatShortDate, parseDate } from '../../helpers/dateHelper'
import { Badge, Tooltip } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'
import { CalendarMonthRegular } from '@fluentui/react-icons'

type Props = {
    date: AnyDate
    format?: DateFormats
    className?: string
}

export default function FormattedDateBadge(props: Props): ReactElement {
    const { i18n } = useTranslation()

    const dateString = useMemo(() => formatShortDate(props.date), [i18n.language])
    const tooltipString = useMemo(
        () => parseDate(props.date, { locale: i18n.language })?.toFormat(props.format || DateFormats.Full) || '',
        [i18n.language],
    )

    return (
        <Tooltip content={tooltipString} relationship="label" withArrow>
            <Badge size="medium" icon={<CalendarMonthRegular />} appearance="tint">
                {dateString}
            </Badge>
        </Tooltip>
    )
}
